var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserScanLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#880CE8",
    strokeLinecap: "round",
    d: "M30.625 6.125h3.2c1.791 0 2.687 0 3.243.556.557.557.557 1.453.557 3.244v3.2m-7 22.75h3.2c1.791 0 2.687 0 3.243-.556.557-.557.557-1.453.557-3.244v-3.2m-26.25-22.75h-3.2c-1.791 0-2.687 0-3.244.556-.556.557-.556 1.453-.556 3.244v3.2m7 22.75h-3.2c-1.791 0-2.687 0-3.244-.556-.556-.557-.556-1.453-.556-3.244v-3.2m7.943-1.465c.867-1.253 2.123-2.303 3.649-3.037 1.526-.734 3.262-1.123 5.033-1.123 1.771 0 3.507.389 5.033 1.123 1.526.734 2.782 1.784 3.65 3.037"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 15.75,
    r: 4.75,
    stroke: "#880CE8",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserScanLight);
export default __webpack_public_path__ + "static/media/user_scan_light.b49630f3dac0744500a326a82ab5c4cd.svg";
export { ForwardRef as ReactComponent };